module.exports = __webpack_public_path__ + "static/media/supply_chain.86a21d1e.png";